import { createContext, useContext, useState, useCallback, useRef, useEffect } from "react";

const ThorContext = createContext(null);

export const useThor = () => {
    const ctx = useContext(ThorContext);
    if (!ctx) throw new Error("useThor must be used inside ThorProvider");
    return ctx;
};

export const ThorProvider = ({ children }) => {
    const [editMode, setEditMode] = useState(false);
    const [toasts, setToasts] = useState([]);
    const [checklistVersion, setChecklistVersion] = useState(0);
    const timerIds = useRef([]);

    const addToast = useCallback((message, type = 'info') => {
        const id = Date.now() + Math.random();
        setToasts(prev => [{ id, message, type }, ...prev]);
        if (type === 'success') setChecklistVersion(v => v + 1);
        const timerId = setTimeout(() => {
            setToasts(prev => prev.filter(t => t.id !== id));
        }, 4000);
        timerIds.current.push(timerId);
    }, []);

    // Cleanup all pending timers on unmount
    useEffect(() => {
        return () => { timerIds.current.forEach(clearTimeout); };
    }, []);

    const dismissToast = useCallback((id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
    }, []);

    return (
        <ThorContext.Provider value={{ editMode, setEditMode, toasts, addToast, dismissToast, checklistVersion }}>
            {children}
        </ThorContext.Provider>
    );
};

export default ThorContext;
